import createCookie from '@/js/components/cookies/createCookie';

export default class Notification {
  constructor(button) {
    this.dom = {
      button,
    };

    this.dom.button.addEventListener('click', () => createCookie('notification-closed', 1, 5));
  }
}
